
import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Sparkles } from "lucide-react";
import MiniGame, { MiniGameConfig } from "./MiniGame";
import DailyQuote from "./motivation/DailyQuote";
import BrainBreaks from "./motivation/BrainBreaks";

const MotivationCorner = () => {
  const [activeGame, setActiveGame] = useState<MiniGameConfig | null>(null);
  
  const playGame = (game: MiniGameConfig) => {
    setActiveGame(game);
  };
  
  const closeGame = () => {
    setActiveGame(null);
  };
  
  return (
    <Card className="bg-card rounded-lg shadow-sm border">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2">
          <Sparkles className="h-5 w-5 text-yellow-500" />
          Motivation Corner
        </CardTitle>
        <CardDescription>Daily inspiration and mental breaks</CardDescription>
      </CardHeader>
      
      <CardContent className="space-y-6">
        {/* Daily Quote */}
        <DailyQuote />
        
        {/* Mini Games */}
        <BrainBreaks onPlayGame={playGame} />
        
        {/* Active Game */}
        {activeGame && (
          <div className="bg-muted/50 rounded-lg border p-4">
            <MiniGame 
              config={activeGame}
              onClose={closeGame}
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default MotivationCorner;
